import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';


const resetPasswordReqHandler = {

  resetSmsPasswordRequest: (opts: {email: string}): Promise<ApiResponse<{token: string}>> => {
    
    return genericApi.post(`password_reset_request/sms`, opts);
  },

  resetManualPasswordRequest: (opts: {idGha?: number, idFwd?:number, firstName: string, lastName?: string}): Promise<ApiResponse<{token: string}>> => {
    
    return genericApi.post(`password_reset_request/manual`, opts);
  },

  verifyResetPasswordRequestCode: (token: string, pin: string): Promise<ApiResponse<undefined>> => {
    
    return genericApi.post(`password_reset/pin/verify`, {token, pin});
  },

  submitSmsPinWithNewPassword: (opts: {password: string, confirmPassword: string, token: string, pin: string}): Promise<ApiResponse<undefined>> => {
    return genericApi.post(`password_reset/pin`, opts);
  }

};

export default resetPasswordReqHandler